const parsedDefaultAiSearchAccuracy = parseFloat(process.env.REACT_APP_DEFAULT_AI_SEARCH_ACCURACY);

export const DEFAULT_AI_SEARCH_ACCURACY = Number.isNaN(parsedDefaultAiSearchAccuracy)
  ? 0.7
  : parsedDefaultAiSearchAccuracy;
